import request from '@utils/request'

export const state = {}

export const mutations = {}

export const actions = {
  /*
   * 取得投資人專區
   * */
  fetchInvestor({ commit, getters }) {
    return request
      .get(`/static/investor`)
      .then((response) => response.items)
  },
  /*
   * 取得關於零壹
   * */
  fetchAbout({ commit, getters }) {
    return request
      .get(`/static/about01`)
      .then((response) => response.items)
  },
  /*
   * 取得菁英招募
   * */
  fetchElite({ commit, getters }) {
    return request
      .get(`/static/recruit`)
      .then((response) => response.items)
  },
}